// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const GlobalStyles = {
  color: {
    COLOR_PRIMARY: 'rgba(255, 255, 255, 1)',
    COLOR_SECONDARY: 'rgb(91, 220, 255)',
    COLOR_GREY: 'rgb(49, 72, 99)',
    COLOR_BLACK_GREY: 'rgb(49, 49, 49)',
    COLOR_BLUE: 'rgb(40, 170, 222)',
    COLOR_BLUE_LIGHTER: 'rgb(117, 204, 248)',
    COLOR_YELLOW_SELECT: 'rgb(252, 195, 56)',
    COLOR_GREEN: 'rgb(101, 224, 161)',
    COLOR_BLACK_GREEN: 'rgb(41, 214, 105)',
    COLOR_REJECT: 'rgb(252, 77, 118)',
    COLOR_SHADOW: '0px 0px 20px -10px rgba(0,0,0,0.75)',
    COLOR_SHADOW_HOVER: '0px 0px 20px -7px rgba(0,0,0,0.75)',
    COLOR_DEFAULT: 'rgba(230, 230, 230, 1)',
    COLOR_INPUT: 'rgb(112, 128, 144)',
    COLOR_GRAY: '#7B7B7B',
    COLOR_LIGHT_GRAY: '#CACACA',
  },
  fonts: {
    FONT_SIZE_MINI: 13,
    FONT_SIZE_SMALL: 14,
    FONT_SIZE: 16,
    FONT_SIZE_TITLE: 18,
    FONT_SIZE_LARGE: 22,
    FONT_SIZE_MAX: 24,
    FONT_SIZE_EXTRA_MAX: 45,

    FONT_ANLTP_REGULAR: 'AvenirNextLTPro-Regular',
    FONT_ANLTP_BOLD: 'AvenirNextLTPro-Bold',
    FONT_MONTSERRAT_MEDIUM: 'Montserrat-Medium',
    FONT_MONTSERRAT_BOLD: 'Montserrat-Bold',
  },
};

export default GlobalStyles;
